import '../../style/index.less'
import './index.less'



// WEBPACK FOOTER //
// ./components/pagination/style/index.js